<template>
    <div class="container-fluid">
      
        <carousel :items="fields.images"></carousel>
        <mainlinks :links="fields.midlinks"></mainlinks>
        <about :detail="fields.aboutDetail"></about>
        <special :link="fields.special"></special>
        <weddinglinks></weddinglinks>
        <instagram></instagram>
        <content-section :contents="fields.sections"></content-section>
        <contact></contact>
        
        
    </div>
</template>
<script>
import Carousel from '../components/Carousel.vue'
import Mainlinks from '../components/Mainlinks.vue'
import About from '../components/About.vue'
import Instagram from '../components/Instagram.vue'
import Special from '../components/Special.vue'
import ContentSection from '../components/ContentSection.vue'
import Contact from '../components/Contact.vue'
import Weddinglinks from '../components/Weddinglinks'
import classie from 'classie'
import Dialog from '../components/Dialog.vue'
import { create } from 'vue-modal-dialogs'



export default {
    name: 'Home',
    data () {
      return {
        documentId: '',
        fields: {
          title: null,
          images: null,
          midlinks: null,
          aboutDetail: null,
          sections: null,
          special: null
        },
        modalFields: {
          text: null,
          show: null
        }
      }
    },
    components: {
        Carousel,
        Mainlinks,
        About,
        Instagram,
        Special,
        ContentSection,
        Contact,
        Weddinglinks,
        Dialog
    },
    methods: {
      getContent (uid) {
        this.$prismic.client.getByUID('homepage', uid)
          .then((document) => {
            if (document) {
              console.log(document.data);
              this.documentId = document.id
              this.fields.title = document.data.page_title
              this.fields.images = document.data.carousel
              this.fields.midlinks = {
                link1: {
                  img: document.data.image_menu_1,
                  text: document.data.link1_text,
                  url: document.data.link1_url
                }
              },
              this.fields.aboutDetail = {
                pic: document.data.what_is_brigadeiro_image,
                text: document.data.what_is_brigadeiro_text
              },
              this.fields.sections = document.data.body
              this.fields.special = document.data.specials
            } else {
              this.$router.push({ name: 'not-found' })
               
            }
          })
      },
      getModalInfo (){
        this.$prismic.client.getByUID('dialogbox','soldout')
         .then((document) => {
                  if(document){
                    this.modalFields.show = document.data.show_message;
                    this.modalFields.text = document.data.message_text;
                    this.modalFields.img = document.data.dialog_img.url;
                  }
                });
      },
      showMessage () {
        var messageBox = create(Dialog,'content');
        
          messageBox(this.modalFields);
      }
    },
    created () {
      
      this.getContent('home')
        window.onload = init();
        this.getModalInfo();
        
    },
    watch: {
      modalFields: {
        deep: true,
        handler(newvalue, old){
          console.log(this.modalFields.show)
          if(this.modalFields.show)
            this.showMessage();
        }
      }
    },
    mounted () {
      
    }
}
function init(){
    window.addEventListener('scroll', function(e){
        var distanceY = window.pageYOffset || document.documentElement.scrollTop,
            shrinkOn = 200,
            header = document.querySelector("#pagelogo"),
            header_parent = document.querySelector("#pagelogo-a");
        if (distanceY > shrinkOn) {
            classie.add(header, "smaller");
            classie.add(header_parent, "smaller");
        } else {
            if (classie.has(header,"smaller")) {
                classie.remove(header, "smaller");
                classie.remove(header_parent, "smaller");
            }
        }
    });
    
}
</script>
<style lang="scss">
    .main-div {
        span {
            color: red;
        }
    }
</style>